import { render, staticRenderFns } from "./StarsDetailV2.vue?vue&type=template&id=c36eb332&scoped=true"
import script from "./StarsDetailV2.vue?vue&type=script&lang=js"
export * from "./StarsDetailV2.vue?vue&type=script&lang=js"
import style0 from "./StarsDetailV2.vue?vue&type=style&index=0&id=c36eb332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36eb332",
  null
  
)

export default component.exports